import React from "react";
import ProgressBar from '@atlaskit/progress-bar';

interface IProgressBar {
  value?: number
  isIndeterminate?: boolean
}
export interface IProps {
  type: "linear";
}

const types = {
  // circular: (props: CircularProgressProps) => <CircularProgress {...props} />,
  linear: (props: IProgressBar) => <ProgressBar {...props} />,
};

export const Progress: React.FC<
  IProps
  // & CircularProgressProps
  & IProgressBar
> = (props) => types[props.type](props);
